export default __webpack_public_path__ + "static/media/l2.60c00d27.png";